import Link from "next/link";
import { useRouter } from "next/router";
import React, { useCallback } from "react";
import { Button } from "@/components/Buttons/index";
import { useModal } from "@/hooks";
import config from "@/lib/config";
import { idcLoginUrl, idcSignupUrl } from "@/lib/constants";
import loginStyles from "@/styles/Login.module.scss";
import processStyles from "@/styles/Process.module.scss";
import IdcSignUpModal from "../IdcSignupModal";

// ログイン画面1
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LoginForm(props) {
  const router = useRouter();
  const {
    showModal,
    hideModal
  } = useModal();
  const onClickHandle = useCallback(url => {
    hideModal();
    props === null || props === void 0 || props.setIsSignupClicked(true);
    router.push(url);
  }, []);
  const showSignupModal = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(IdcSignUpModal, {
      onClickHandle: () => onClickHandle(idcSignupUrl)
    }), {
      closeButton: true,
      outerAreaClose: true,
      style: "dialogue"
    });
  }, [onClickHandle]);
  console.log("sentry", process.env);
  return /*#__PURE__*/_jsx("div", {
    className: loginStyles.contentWrapper,
    children: /*#__PURE__*/_jsxs("div", {
      className: loginStyles.loginSet,
      children: [/*#__PURE__*/_jsx("div", {
        className: `${loginStyles.formSection}`,
        children: /*#__PURE__*/_jsxs("div", {
          className: loginStyles.sectionInner,
          style: {
            padding: "1em"
          },
          children: [/*#__PURE__*/_jsx("p", {
            className: loginStyles.sectionTitle,
            style: {
              fontSize: "16px",
              fontWeight: "bold"
            },
            children: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3092\u304A\u6301\u3061\u306E\u65B9"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
            className: loginStyles.button,
            children: /*#__PURE__*/_jsx(Button, {
              onClick: () => onClickHandle(idcLoginUrl),
              fontBold: true,
              fillColor: true,
              large: true,
              largeFont: true,
              fontFixed: true,
              children: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3067\u30ED\u30B0\u30A4\u30F3"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: "\u203B\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BA\u306E\u30B5\u30A4\u30C8\u3078\u79FB\u52D5\u3057\u307E\u3059"
          })]
        })
      }), /*#__PURE__*/_jsx("hr", {
        style: {
          width: "100%",
          borderColor: "#101010"
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: `${loginStyles.loginSection} ${loginStyles.formSection}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: loginStyles.flexTitle,
          children: /*#__PURE__*/_jsxs("p", {
            className: loginStyles.sectionTitle,
            children: ["\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3092\u304A\u6301\u3061\u3067\u306F\u306A\u3044\u65B9", /*#__PURE__*/_jsx("br", {})]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: loginStyles.sectionInner,
          children: /*#__PURE__*/_jsx("p", {
            className: loginStyles.button,
            children: /*#__PURE__*/_jsx(Button, {
              onClick: showSignupModal,
              fontBold: true,
              fillColor: true,
              large: true,
              largeFont: true,
              fontFixed: true,
              children: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u65B0\u898F\u4F1A\u54E1\u767B\u9332"
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: loginStyles.caption_white_left,
          children: "\u203BSPOOX\u306E\u3054\u5229\u7528\u306B\u306F\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u304C\u5FC5\u8981\u3068\u306A\u308A\u3001SPOOX ID\u3067\u306E\u30ED\u30B0\u30A4\u30F3\u306F\u51FA\u6765\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002"
        }), /*#__PURE__*/_jsx("div", {
          className: loginStyles.caption_left,
          children: "\u203BSPOOX ID\u3092\u304A\u6301\u3061\u306E\u65B9\u306F\u3001\u540C\u3058\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3068\u3057\u3066\u3054\u767B\u9332\u304F\u3060\u3055\u3044\u3002"
        }), /*#__PURE__*/_jsxs("div", {
          className: processStyles.link,
          children: ["\u304A\u624B\u7D9A\u304D\u65B9\u6CD5\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
            href: config.idc.membersIdInfo,
            className: "underline",
            children: "\u3053\u3061\u3089"
          })]
        })]
      })]
    })
  });
}